import { supabase } from './supabase';

/**
 * tabletHeartbeat.ts — Battement de cœur de la tablette cuisine (Chantier 2).
 *
 * La tablette appelle la RPC `tablet_heartbeat` toutes les ~60 s (et tout de
 * suite au montage). Si plus de heartbeat au-delà du seuil (5 min) pendant les
 * heures d'ouverture, l'Edge Function `ops-check` alerte Ahmed + le resto.
 *
 * Best-effort : aucune erreur ne doit perturber l'écran caisse.
 */

const HEARTBEAT_INTERVAL_MS = 60_000;

async function ping(tenantId: string): Promise<void> {
  try {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : null;
    await supabase.rpc('tablet_heartbeat', { p_tenant_id: tenantId, p_user_agent: ua });
  } catch {
    /* silencieux : un ping raté sera réessayé au prochain tick */
  }
}

/**
 * Démarre les pings périodiques pour ce tenant. Renvoie une fonction d'arrêt
 * (à appeler au démontage). Ping immédiat puis toutes les 60 s.
 */
export function startTabletHeartbeat(tenantId: string): () => void {
  if (!tenantId) return () => {};
  void ping(tenantId);
  const id = setInterval(() => void ping(tenantId), HEARTBEAT_INTERVAL_MS);
  return () => clearInterval(id);
}
